// Initialize foundation for any elements that may have been dynamically added though a modal
$(document).on('open.zf.reveal', '[data-reveal]', function () {
    $(document).foundation();
});
